import { Tab as T } from 'react-tabs';

export default T;
